import React from "react";
import { Form } from "react-bootstrap";

export const CalculatorField = ({ title, errMsg, fieldName, handleChange, fieldValue, fieldInvalid, isDisabled = false, placeholder, bold ,handleBlur}) => {
  return (
    <Form.Group 
      controlId={`form${fieldName}Score`}>
      <Form.Label aria-label={title}>{ title }</Form.Label>
      <div className="score">
          <Form.Control 
            value={ fieldValue || ""}
            readOnly={isDisabled}
            placeholder={!isDisabled ? (placeholder) : "" } 
            className={`${(fieldInvalid && !isDisabled) ? "is-invalid" : ""} ${bold ? "font-bold" : ""}`}
            name={fieldName}
            onChange={(e) => handleChange(fieldName, e.target)} 
            aria-invalid={fieldInvalid && !isDisabled}
            aria-describedby={ (fieldInvalid && !isDisabled) ? errMsg : ""}
            type="number"
            onWheelCapture={e => {e.target.blur()}}
            onBlur={handleBlur}
            aria-label={!placeholder ? `הזנת ${title}` : placeholder}
          /> 
      </div>
    </Form.Group>
  )
}